import {photoPurchaseSnapshot} from './photo-purchase-snapshot';
import type {BunkSelection} from '../BunkOptions';
import {BED_OPTIONS} from '../design/configurator/room/beds';
import {bunkSleepCapacity} from '../planned-bunk-choices';
import type {BasicUpgrades} from '../../../../shared/basicUpgrades';
import {bunkProfile} from '../design/configurator/room/bunk-profile';
import {ERNST_SPAN,ERNST_DEPTH} from './ernst-layout';
export type RoomMeasurements={span?:string|number;depth?:string|number};
export const measuredInches=(value:unknown)=>{const n=Number(value);return Number.isFinite(n)&&n>0?n:undefined;};
/** Footprint screening only. Photo framing is not evidence of physical fit. */
export function footprintStatus(width:number,depth:number,measurements:RoomMeasurements){
 const span=measuredInches(measurements.span),availableDepth=measuredInches(measurements.depth);
 if((span!==undefined&&span<width)||(availableDepth!==undefined&&availableDepth<depth))return 'too-small';
 return span!==undefined&&availableDepth!==undefined?'within-measurements':'unconfirmed';
}
export const ernstFitStatus=(measurements:RoomMeasurements)=>footprintStatus(ERNST_SPAN,ERNST_DEPTH,measurements);
export function retainedBasicSelections<T extends {choice:number}>(choices:number[],previous:T[]){
 const available=[...previous];
 return choices.map(choice=>{const index=available.findIndex(b=>b.choice===choice);return index>=0?available.splice(index,1)[0]:undefined;});
}
export function basicAlternatives(measurements:RoomMeasurements,previous:{choice:number;upgrades?:BasicUpgrades}[]=[],singleOnly=false){
 // Retain four mattresses where possible; report sleeping capacity explicitly.
 const candidates=singleOnly?BED_OPTIONS.map((_,choice)=>[choice]):[[3,3],[2,2],[0,3],[0,2],[0,0],[3],[2],[0],[1],[5],[4]];
 return candidates.map(choices=>{
  const retained=singleOnly?[previous[0]]:retainedBasicSelections(choices,previous);
  const footprints=choices.map((choice,index)=>{
   const bed=BED_OPTIONS[choice],extra=retained[index]?.upgrades??{};
   const {upperY}=bunkProfile(80),risers=Math.max(2,Math.round(upperY/12));
   const stairWidth=2.5+21+(risers-1)*12+(extra.stairDrawers?.8:0);
   return {width:Math.max(bed.width,extra.stairs?stairWidth:0),depth:bed.depth+(extra.stairs?21:0)};
  });
  const width=footprints.reduce((sum,unit)=>sum+unit.width,0)+4*(choices.length-1);
  const depth=Math.max(...footprints.map(unit=>unit.depth));
  return {choices,width,depth,capacity:bunkSleepCapacity(choices),status:footprintStatus(width,depth,measurements),label:choices.map(i=>BED_OPTIONS[i].name).join(' + ')};
 }).filter(option=>option.status!=='too-small');
}

/** One photographed room keeps every selected unit and its independent extras. */
export function photoCombinationSnapshot(bunks:BunkSelection[]){
 return photoPurchaseSnapshot(bunks.map(b=>b.choice),bunks.map(b=>b.upgrades),bunks.map(b=>b.finish),bunks.map(b=>b.customColorCode));
}


